import { useEffect, useState } from "react";
import { UserTabs } from "../../users/components/UserTabs";
import { useNavigate } from "react-router-dom";
import localization from "../../../config/localization";
import withdrawService from "../services/withdraw.service";
import { UserPendingWithdrawalResponse } from "../models";
import { Button, Card, CardBody } from "../../../components/ui";
import { DeviceType } from "../../../models/constants/deviceType";
import userDeviceStore from "../../../store/device.store";
import { increaseInboxUnreadCount } from "../../users/reducers/userProfileReducer";
import { useAppDispatch } from "../../../store/hooks";

export function WithdrawUnderApproval() {

  const [activeTab, setActiveTab] = useState<string>("withdrawal");
  const [userPendingWithdrawal, setUserPendingWithdrawal] =
    useState<UserPendingWithdrawalResponse | null>(null);
  const navigate = useNavigate();
  const deviceType = userDeviceStore((state) => state.deviceType);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(increaseInboxUnreadCount());
    init();
  }, []);

  const init = async () => {
    const response = await withdrawService.getUserPendingWithdrawals();
    if (response) {
      setUserPendingWithdrawal(response);
    } else {
      navigate("/withdrawhistory");
    }
  };

  const onTabChange = (tab: string) => {
    navigate(`/${tab}`);
    setActiveTab(tab);
  };

  const content = (
    <div>
      <div
        className={
          deviceType !== DeviceType.Web
            ? "border-2 border-[#2C2C2C] rounded-2xl m-4 px-4 py-6 bg-black-gradient"
            : ""
        }
      >
        <div className="relative mx-auto h-[140px] w-[140px] flex items-center justify-center">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="absolute h-28 w-28 rounded-full bg-[#6b3a0e] blur-[45px] opacity-70" />
            <div className="absolute h-20 w-20 rounded-full bg-[#ff8a1f] blur-[30px] opacity-60" />
          </div>
          <img
            src={"/images/img-timer.svg"}
            alt="Withdraw Under Process"
            className="relative z-20 w-28 h-28"
          />
        </div>

        <h2 className="text-center text-lg font-medium text-white">
          {localization.withdraw_process}
        </h2>

        <div
          className={
            deviceType === DeviceType.Web
              ? "mt-8 space-y-3"
              : "mt-8 space-y-5 text-sm"
          }
        >
          <div className="flex justify-between items-center">
            <span
              className={
                deviceType === DeviceType.Web
                  ? "text-lg leading-7 text-[#A9A9A9] font-medium"
                  : "text-xs text-[#C7C7CC] font-regular"
              }
            >
              {localization.withdrawal_amount}
            </span>
            <div className="flex items-center">
              <span
                className={
                  deviceType === DeviceType.Web
                    ? "text-lg leading-7 text-white font-medium"
                    : "text-lg text-white font-semibold"
                }
              >
                {" "}
                {`\u20B9${Number(userPendingWithdrawal?.amount)?.toFixed(2)}`}
              </span>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <span
              className={
                deviceType === DeviceType.Web
                  ? "text-lg leading-7 text-[#A9A9A9] font-medium"
                  : "text-xs text-[#C7C7CC] font-regular"
              }
            >
              {localization.withdrawal_fee}
            </span>
            <div className="flex items-center">
              <span
                className={
                  deviceType === DeviceType.Web
                    ? "text-lg leading-7 text-white font-medium"
                    : "text-lg text-white font-semibold"
                }
              >
                {" "}
                {`\u20B9${Number(userPendingWithdrawal?.fee ?? 0)?.toFixed(2)}`}
              </span>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <span
              className={
                deviceType === DeviceType.Web
                  ? "text-lg leading-7 text-[#A9A9A9] font-medium"
                  : "text-xs text-[#C7C7CC] font-regular"
              }
            >
              {localization.withdraw_get}
            </span>
            <div className="flex items-center">
              <span
                className={
                  deviceType === DeviceType.Web
                    ? "text-[18px] leading-7 text-[#3BDC80] font-medium"
                    : "text-[22px] text-[#3BDC80] font-semibold"
                }
              >
                {" "}
                {`\u20B9${Number(userPendingWithdrawal?.realamount ?? 0)?.toFixed(2)}`}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 space-y-4 flex justify-center">
          <Button
            type="submit"
            className={`py-4 text-white ${deviceType === DeviceType.Web ? "h-[52px] text-base" : "text-sm"} font-medium bg-primary-gradient rounded ${deviceType !== DeviceType.Web ? "w-full" : "w-[80%]"}`}
            onClick={() => navigate("/withdrawhistory")}
          >
            <div className="flex items-center justify-center gap-2">
              <img
                src={"/icons/ic-rotate.svg"}
                alt="save-image"
                className="w-5 h-5"
              />
              <span>{localization.withdraw_status}</span>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );

  return deviceType !== DeviceType.Web ? (
    <div>
      <UserTabs activeTab={activeTab} onTabChange={onTabChange} />
      {content}
    </div>
  ) : (
    <div>
      <UserTabs activeTab={activeTab} onTabChange={onTabChange} />
      <Card>
        <CardBody showGradient>
          <div className="w-full max-w-md mx-auto">{content}</div>
        </CardBody>
      </Card>
    </div>
  );
}
